import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ScrollTopBehaviour from "../components/ScrollTopBehaviour";

import HomeLightAnimation from "../views/all-home-version/HomeLightAnimation";

const Preview = lazy(() => import("../views/Preview"));
const LightProfessionalAnimation = lazy(() => import("../views/all-home-version/LightProfessionalAnimation"));
const HomeLightProfessional2 = lazy(() => import("../views/all-home-version/HomeLightProfessional2"));
const HomeLightRtlAnimation = lazy(() => import("../views/all-home-version/HomeLightRtlAnimation"));
const HomeDarkParticles = lazy(() => import("../views/all-home-version/HomeDarkParticles"));
const HomeDarkAnimation = lazy(() => import("../views/all-home-version/HomeDarkAnimation"));
const NotFound = lazy(() => import("../views/NotFound"));

const AllRoutes = () => {
  return (
    <>
      <ScrollTopBehaviour />
      <Suspense fallback={<div className="loading-container"></div>}>
        <Routes>
          <Route path="/" element={<HomeLightAnimation />} />
          <Route path="/home-light-animation" element={<HomeLightAnimation />} />
          <Route path="/home-light-rtl-animation" element={<HomeLightRtlAnimation />} />
          <Route path="/dark-particle-effect" element={<HomeDarkParticles />} />
          <Route path="/home-light-professional" element={<LightProfessionalAnimation />} />
          <Route path="/home-light-professional-2" element={<HomeLightProfessional2 />} />
          <Route path="/home-dark-animation" element={<HomeDarkAnimation />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </>
  );
};

export default AllRoutes;
